import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";

const questionAPI = createApi({
    reducerPath: 'questionAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getQuestionList: builder.mutation({
            query: (userQuery) => ({
                url: '/Question/GetQuestionList',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addQuestion: builder.mutation({
            query: (data) => ({
                url: '/Question/AddQuestion',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateQuestion: builder.mutation({
            query: (data) => ({
                url: '/Question/UpdateQuestion',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getQuestionById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Question/GetQuestionById/?id=${Number(id)}`),
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteQuestion: builder.mutation({
            query: (id) => ({
                url: `/Question/DeleteQuestion/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        })

    })
})

export const { useAddQuestionMutation, useGetQuestionListMutation,
    useLazyGetQuestionByIdQuery, useUpdateQuestionMutation,
    useDeleteQuestionMutation } = questionAPI;

export default questionAPI;